var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "650", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary white--text",
                flat: _vm.insideEmptyContent,
              },
              on: { click: _vm.resetProfile },
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v("\n        mdi-plus-circle-outline\n      "),
              ]),
              _vm._v("\n      Novo Perfil\n    "),
            ],
            1
          ),
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { color: "success", dark: "", flat: "" } },
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          !!_vm.profile.id ? "Editar Perfil" : "Novo Perfil"
                        ) +
                        "\n        "
                    ),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "" },
                      on: { click: _vm.closeAndClearDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nome do Perfil",
                                  rules: [_vm.validationRules.required],
                                },
                                model: {
                                  value: _vm.profile.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.profile, "name", $$v)
                                  },
                                  expression: "profile.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "error" },
                          on: { click: _vm.closeAndClearDialog },
                        },
                        [_vm._v("\n            Cancelar\n          ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success", disabled: !_vm.valid },
                          on: { click: _vm.save },
                        },
                        [_vm._v("\n            Salvar\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }